// ===========================================
// Configuración de entorno del frontend
// ===========================================

interface EnvConfig {
  apiUrl: string
  appUrl: string
  isProduction: boolean
}

function getConfig(): EnvConfig {
  // In production, use same-origin (proxied via _redirects)
  // In development, Vite proxy handles /api -> localhost:8787
  const apiUrl = import.meta.env.VITE_API_URL || ''
  const appUrl = import.meta.env.VITE_APP_URL || window.location.origin

  return {
    apiUrl,
    appUrl,
    isProduction: import.meta.env.PROD,
  }
}

export const config = getConfig()

// Vite environment types - these extend the global types from vite/client
// The actual type declarations are in vite-env.d.ts
